import React, { useState } from "react";
import { Redirect, Route } from "react-router-dom";

import { useAuthentication } from "../../context/AuthenticationContext";

const AuthRedirectRoute = (props) => {
  const { token, redirect_path } = useAuthentication();
  const [hasToken] = useState(![null, undefined].includes(token));
  return token ? (
    <Redirect
      to={{
        pathname: redirect_path,
        state: { noAnimate: hasToken },
      }}
    />
  ) : (
    <Route {...props} />
  );
};

export default AuthRedirectRoute;
